import { CameraSmile02Icon } from '@hugeicons/core-free-icons';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { FormMessage, MessageType } from 'components/FormComponents/FormMessage/FormMessage';

import Selfie from '../Selfie';

export const SelfieModal = ({
  show,
  brand,
  screenName,
  noClose = false,
  title = 'Take selfie',
  description,
  onSave = () => {},
  onClose = () => {},
}) => {
  return (
    <AnimatedModal
      visible={show}
      noClose={noClose}
      title={title}
      description={description}
      small
      oldIconLibrary={false}
      icon={CameraSmile02Icon}>
      {show && (
        <Selfie onSave={onSave} brand={brand} screenName={screenName} noBackButton={noClose} />
      )}
    </AnimatedModal>
  );
};
